import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { AppConfig, moduli } from '../../config';
import { IzvjestajZavrsenihRnService } from './izvjestaj-zavrsenih-rn.service';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

@Component({
  selector: 'app-izvjestaj-zavrsenih-rn',
  templateUrl: './izvjestaj-zavrsenih-rn.component.html',
  styleUrls: ['./izvjestaj-zavrsenih-rn.component.scss'],
})
export class IzvjestajZavrsenihRnComponent implements OnInit {
  izvjestaji: any = [];
  normativi: [] = [];
  izvjestaj: any;
  idPlanProizvodnje: number;
  procesiVrijeme: any;
  podaciPlan: [] = [];
  procesi: any;
  strojevi: any;
  djelatniciPlan: any;
  djelatniciOstvareno: any;
  planiranoVrijeme: any;
  ostvarenoVrijeme: any;
  datumOd = moment().subtract(1, 'days');
  datumDo = moment();
  datumOdFormatiran: string = this.datumOd.format('YYYY-MM-DD');
  datumDoFormatiran: string = this.datumDo.format('YYYY-MM-DD');
  idPlan: any;

  // OTP
  otp: any = [];
  rezultat: any = [];
  idOstaliTroskoviProizvodnje: any;
  procesIdproces: any;
  strojIdstroj: any;
  otpUkupnododatak: any;
  otpNazivdodatka: any;
  otpUkupnoekstradodatak: any;
  otpNapomena: any;
  planProizvodnjeIdPlanProizvodnje: any;

  //SLIKE KOMENTARI
  nazivTablice: any;
  URL: any = AppConfig.IPfile;
  token: any;
  isLoading: boolean = true;
  sviDokumenti: any = [];
  napomena_komentar: any = [];

  dozvoli_export: boolean = false;

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(
    private service: IzvjestajZavrsenihRnService,
    private router: Router
  ) {
    this.token = sessionStorage.getItem('token');

    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().dnevniIzvjestajZavrsenihRN;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  ngOnInit() {
    this.dohvatiIzvjestaje(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  dohvatiIzvjestaje(datumod: string, datumdo: string): void {
    this.izvjestaji = [];
    this.dozvoli_export = false;
    let data = {
      datumod: datumod,
      datumdo: datumdo,
    };
    //console.log(data);
    this.service.dohvatiIzvjestaje(data).subscribe((res) => {
      //console.log(res);
      if (res.success === true) {
        this.izvjestaji = res.data;
      }
      if (res.data.length > 0) {
        this.dozvoli_export = true;
      }else{
        this.dozvoli_export = false;
      }
    });
  }

  onRowClick(e) {
    if (e.rowType === 'data' && e.handled !== true) {
      var key = e.component.getKeyByRowIndex(e.rowIndex);
      var expanded = e.component.isRowExpanded(key);
      if (expanded) {
        e.component.collapseRow(key);
      } else {
        e.component.expandRow(key);
      }
    }
  }

  dohvatiOdstupanja(e: any): void {
    //console.log(e);
    e.component.collapseAll(-1);
    e.component.expandRow(e.currentSelectedRowKeys[0]);
    this.idPlanProizvodnje = e.selectedRowsData[0].idplanproizvodnje;
    //console.log(this.idPlanProizvodnje);
    this.podaciPlan = [];
    this.procesiVrijeme = [];
    this.procesi = [];
    this.strojevi = [];
    this.normativi = [];

    //OTP
    this.otp = [];
    this.idOstaliTroskoviProizvodnje = [];
    this.procesIdproces = [];
    this.strojIdstroj = [];
    this.otpUkupnododatak = [];
    this.otpNazivdodatka = [];
    this.otpUkupnoekstradodatak = [];
    this.otpNapomena = [];
    this.planProizvodnjeIdPlanProizvodnje = [];

    this.service
      .dohvatiOdstupanja({ idplanproizvodnje: this.idPlanProizvodnje })
      .subscribe((res) => {
        //console.log('RES PRVI: ', res);
        if (res.success === true) {
          this.podaciPlan = res.podaciplan;
          this.procesiVrijeme = res.procesvrijeme;
          this.procesi = res.procesi;
          this.strojevi = res.strojevi;
          this.normativi = res.normativ;
          this.djelatniciPlan = res.djelatniciplan;
          this.djelatniciOstvareno = res.djelatniciostvareno;
          this.planiranoVrijeme =
            res.ukupnoplaniranovrijemeradnika[0].ukupnoplaniranovrijemeradasvihdjelatnika;
          this.ostvarenoVrijeme =
            res.ukupnoostvarenovrijemeradnika[0].ukupnoostvarenovrijemesvihradnikauminutama;
        }
      });

    //API ZA OTP I PODACI OTP-a
    this.service
      .dohvatiOTP({ idplanproizvodnje: this.idPlanProizvodnje })
      .subscribe((res) => {
        //console.log('RES DRUGI: ', res);
        if (res.success === true) {
          this.otp = res.data;
          this.idOstaliTroskoviProizvodnje = res.idostalitroskoviproizvodnje;
          this.procesIdproces = res.proces_idproces;
          this.strojIdstroj = res.stroj_idstroj;
          this.otpUkupnododatak = res.otp_ukupnododatak;
          this.otpNazivdodatka = res.otp_nazivdodatka;
          this.otpUkupnoekstradodatak = res.otp_ukupnoekstradodatak;
          this.otpNapomena = res.otp_napomena;
          this.planProizvodnjeIdPlanProizvodnje =
            res.planproizvodnje_idplanproizvodnje;
        }
      });

    //ZA DOHVAĆANJE SLIKA I PRIKAZ (ODNOSNO AKO JE PRAZNO NE ISPISUJE NIŠTA)
    this.isLoading = true;
    this.sviDokumenti = [];
    this.service
      .datotekaPopis({
        idplanproizvodnje: this.idPlanProizvodnje,
        nazivtablice: 'planskakalkulacija',
      })
      .subscribe((res) => {
        //console.log('RES TREĆI: ', res);
        if (res.success == true) {
          this.isLoading = false;
          //this.sviDokumenti = res.data;
          let brojac = 1;
          for (let data of res.data) {
            let arr = { ...data, redni_broj: brojac++ };
            this.sviDokumenti.push(arr);
          }
          //console.log('SVI DOKUMENTI: ', this.sviDokumenti);
        } else {
          this.sviDokumenti = [];
        }
      });

    //ZA DOHVAĆANJE KOMENTARA I PRIKAZ (ODNOSNO AKO JE PRAZNO NE ISPISUJE NIŠTA)
    this.napomena_komentar = [];
    this.service
      .dohvatiPlan({ idplanproizvodnje: this.idPlanProizvodnje })
      .subscribe((res) => {
        //console.log('ČETVRTI RES:', res);
        if (res.success == true) {
          this.napomena_komentar = res.data;
        }
      });
  }

  plinPlaniranoStvarno(rowData) {
    return rowData.pis_potrosnjaplina + '/' + rowData.pis_potrosnjaplina_edit;
  }
  strujaPlaniranoStvarno(rowData) {
    return (
      rowData.pis_potrosnjastrujenastroju +
      '/' +
      rowData.pis_potrosnjastrujenastroju_edit
    );
  }
  vodaPlaniranoStvarno(rowData) {
    return rowData.pis_potrosnjavode + '/' + rowData.pis_potrosnjavode_edit;
  }

  onValueChangedDatumOd(e) {
    this.datumOd = e.value;
    this.datumOdFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiIzvjestaje(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  onValueChangedDatumDo(e) {
    this.datumDo = e.value;
    this.datumDoFormatiran = moment(e.value).format('YYYY-MM-DD');
    this.dohvatiIzvjestaje(this.datumOdFormatiran, this.datumDoFormatiran);
  }

  onExporting_old(e: any) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Izvjestaj');
  
    const headers = [
      'Datum', 
      'Plan', 
      'Linija', 
      'Smjena', 
      'Broj RN', 
      'Početak RN', 
      'Završetak RN', 
      'Šifra artikla', 
      'Naziv artikla', 
      'Ostvarena količina', 
      'Planirana količina', 
      'Razlika u kom', 
      'Ostvareno u %', 
      'Škart',
      'Dobar proizvod'
    ];
  
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(1, index + 1);
      cell.value = header;
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
    });
  
    this.izvjestaji.forEach((zaglavlje, rowIndex) => {
      const dataRow = rowIndex * 1 + 2;
  
      worksheet.getCell(dataRow, 1).value = moment(zaglavlje.datumplana).format('DD.MM.YYYY.');
      worksheet.getCell(dataRow, 2).value = zaglavlje.idplanproizvodnje;
      worksheet.getCell(dataRow, 3).value = zaglavlje.li_naziv;
      worksheet.getCell(dataRow, 4).value = zaglavlje.smjena_idsmjena;
      worksheet.getCell(dataRow, 5).value = zaglavlje.brojnaloga;
      worksheet.getCell(dataRow, 6).value = zaglavlje.datumivrijemepocetka;
      worksheet.getCell(dataRow, 7).value = zaglavlje.datumivrijemezavrsetka;
      worksheet.getCell(dataRow, 8).value = zaglavlje.ar_sifra;
      worksheet.getCell(dataRow, 9).value = zaglavlje.ar_naziv;
      worksheet.getCell(dataRow, 10).value = zaglavlje.ostvarenakolicina;
      worksheet.getCell(dataRow, 11).value = zaglavlje.planiranakolicina;
      worksheet.getCell(dataRow, 12).value = zaglavlje.razlikaukomadima;
      worksheet.getCell(dataRow, 13).value = zaglavlje.postotakdesktop;
      worksheet.getCell(dataRow, 14).value = zaglavlje.rns_skart;
      worksheet.getCell(dataRow, 15).value = zaglavlje.dobarproizvod;
    });
  
    worksheet.columns.forEach((column) => {
      column.width = Math.max(
        (column.header?.length || 0) + 5,
        20
      );
    });

    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength + 2;
    })
  
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'izvjestaj_o_zavrsenim_rn.xlsx');
    });
  }

  // stari klasnicni export
  onExporting_2(e){
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Izvještaj');
    
    // Define custom headers
    const headers = [
      'Datum',
      'Plan',
      'Linija',
      'Smjena',
      'Broj RN',
      'Početak RN',
      'Završetak RN',
      'Šifra artikla',
      'Naziv artikla',
      'Ostvarena količina',
      'Planirana količina',
      'Razlika u kom',
      'Ostvareno u %',
      'Škart',
      'Dobar proizvod'
    ];
  
    // Add headers to worksheet
    worksheet.addRow(headers);
  
    // Style the header row
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E6EF' }
    };
  
    // Add data rows
    e.component.getDataSource().store().load()
      .then((izvjestaji) => {
        izvjestaji.forEach(item => {
          worksheet.addRow([
            moment(item.datumplana).format('DD.MM.YYYY.'),
            item.idplanproizvodnje,
            item.li_naziv,
            item.smjena_idsmjena,
            item.brojnaloga,
            item.datumivrijemepocetka,
            item.datumivrijemezavrsetka,
            item.ar_sifra,
            item.ar_naziv,
            item.ostvarenakolicina,
            item.planiranakolicina,
            item.razlikaukomadima,
            item.postotakdesktop,
            item.rns_skart,
            item.dobarproizvod
          ]);
        });

        // Auto-fit columns
        /*
        worksheet.columns.forEach(column => {
          column.width = Math.max(
            headers[column.number - 1].length + 2,
            ...worksheet.getColumn(column.number).values
              .map(v => v ? v.toString().length : 0)
          );
        });
        */
  
        worksheet.columns.forEach((column) => {
          column.width = Math.max(
            (column.header?.length || 0) + 5,
            20
          );
        });
    
        /* sirina stupaca i da bude lijep prikaz podataka (da se ne moraju rasirivati stupci kako bi se podaci u celiji vidjeli) */
        worksheet.columns.forEach((column) => {
          let maxLength = 0;
          column.eachCell({ includeEmpty: true }, (cell) => {
            const columnLength = cell.value ? cell.value.toString().length : 10;
            if (columnLength > maxLength) {
              maxLength = columnLength;
            }
          });
          column.width = maxLength < 10 ? 10 : maxLength + 2;
        });
  
        // Save the workbook
        workbook.xlsx.writeBuffer()
          .then(buffer => saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'izvjestaj_o_zavrsenim_rn_new.xlsx'))
          .catch(err => console.error('Error exporting excel:', err));
      });
  
    e.cancel = true;
  };

  // export filtriranih podataka
  onExporting_3(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Izvještaj');
    
    // Define custom headers
    const headers = [
      'Datum',
      'Plan',
      'Linija',
      'Smjena',
      'Broj RN',
      'Početak RN',
      'Završetak RN',
      'Šifra artikla',
      'Naziv artikla',
      'Ostvarena količina',
      'Planirana količina',
      'Razlika u kom',
      'Ostvareno u %',
      'Škart',
      'Dobar proizvod'
    ];
    // Add headers to worksheet
    worksheet.addRow(headers);
  
    // Style the header row
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E6EF' }
    };
  
    // Using the exportDataGrid function from DevExtreme
    const exportingOptions = {
      component: e.component,
      worksheet: worksheet,
      autoFilterEnabled: true,
      customizeCell: function(options) {
        const { gridCell, excelCell } = options;
        
        if(gridCell.rowType === 'data') {
          if(gridCell.column.dataField === 'datumplana') {
            excelCell.value = moment(gridCell.value).format('DD.MM.YYYY.');
          }
        }
      }
    };
    
    // This will export only the filtered data
    exportDataGrid(exportingOptions).then(() => {
      // Auto-adjust column widths
      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const columnLength = cell.value ? cell.value.toString().length : 10;
          if (columnLength > maxLength) {
            maxLength = columnLength;
          }
        });
        column.width = maxLength < 10 ? 10 : maxLength + 2;
      });
      
      // Export to Excel file
      workbook.xlsx.writeBuffer()
        .then(buffer => saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'izvjestaj_o_zavrsenim_rn_new.xlsx'))
        .catch(err => console.error('Error exporting excel:', err));
    });
  
    e.cancel = true;
  }

  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Izvještaj');
    
    const headers = [
      'Datum', 'Plan', 'Linija', 'Smjena', 'Broj RN', 'Početak RN', 'Završetak RN',
      'Šifra artikla', 'Naziv artikla', 'Ostvarena količina', 'Planirana količina',
      'Razlika u kom', 'Ostvareno u %', 'Škart', 'Dobar proizvod'
    ];
    
    worksheet.addRow(headers);
    
    // Style header
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).fill = {
      type: 'pattern',
      pattern: 'solid', 
      fgColor: { argb: 'FFE0E6EF' }
    };

    const dataSource = e.component.getDataSource();
    const store = dataSource.store();
    
    // Pokušajte s store.load()
    store.load({
      filter: dataSource.filter(),
      sort: dataSource.sort()
    }).then((allData) => {
      //console.log('Store loaded data count:', allData.length);
      
      if (allData && allData.length > 0) {
        allData.forEach(item => {
          const row = [
            moment(item.datumplana).format('DD.MM.YYYY.'),
            item.idplanproizvodnje,
            item.li_naziv, 
            item.smjena_idsmjena,
            item.brojnaloga,
            item.datumivrijemepocetka,
            item.datumivrijemezavrsetka,
            item.ar_sifra,
            item.ar_naziv,
            item.ostvarenakolicina,
            item.planiranakolicina,
            item.razlikaukomadima,
            item.postotakdesktop,
            item.rns_skart,
            item.dobarproizvod
          ];
          worksheet.addRow(row);
        });
        
        this.saveExcelFile(workbook, worksheet);
      } else {
        //console.log('No data from store, using fallback...');
        this.fallbackExport(e, workbook, worksheet);
      }
      
    }).catch(err => {
      //console.error('Error loading from store:', err);
      this.fallbackExport(e, workbook, worksheet);
    });

    e.cancel = true;
  }

  saveExcelFile(workbook, worksheet) {
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength + 2;
    });
    
    workbook.xlsx.writeBuffer()
      .then(buffer => saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'izvjestaj_o_zavrsenim_rn_new.xlsx'))
      .catch(err => console.error('Error exporting excel:', err));
  }

  fallbackExport(e, workbook, worksheet) {
    //console.log('Using fallback export - current items only');
    
    const items = e.component.getDataSource().items();
    //console.log('Fallback items count:', items.length);
    
    items.forEach(item => {
      const row = [
        moment(item.datumplana).format('DD.MM.YYYY.'),
        item.idplanproizvodnje,
        item.li_naziv, 
        item.smjena_idsmjena,
        item.brojnaloga,
        item.datumivrijemepocetka,
        item.datumivrijemezavrsetka,
        item.ar_sifra,
        item.ar_naziv,
        item.ostvarenakolicina,
        item.planiranakolicina,
        item.razlikaukomadima,
        item.postotakdesktop,
        item.rns_skart,
        item.dobarproizvod
      ];
      worksheet.addRow(row);
    });
    
    this.saveExcelFile(workbook, worksheet);
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }

  onCellPrepared(options) {
    //console.log(options);
    if (options.rowType == 'data') {
      if (options.column.dataField === "smjena_idsmjena"){
        if (options.value == '1') {
          options.cellElement.classList.add('bojaSmjena1');
        }
        if (options.value == '2') {
          options.cellElement.classList.add('bojaSmjena2');
        }
        if (options.value == '3') {
          options.cellElement.classList.add('bojaSmjena3');
        }
      }
    }
  }
}
